import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Row from "@bappweb/row"
import "../assets/style.scss"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Row>
        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
          <div className="bapp-container">
            <Block className="landing-header-text-wrapper">
              <Block className="landing-header-text">
                <Element type="h2" className="header-text1">
                  {"''Akbank Private Banking'' in ayrıcalıklı hizmetleri için sizi arayalım."}
                </Element>
                <Element type="h2" className="header-text1">
                  {
                    "Konusunda uzman kadrosuyla, ihtiyaçlarınız için size özel bir bankacılık hizmeti."
                  }
                </Element>
                <ul className="header-text2">
                  <li>
                    <Element type="p">
                      {"Bütünsel varlık yönetimi bakış açısıyla"}
                      <b>{" en uygun finansal çözümler"}</b>
                    </Element>
                  </li>
                  <li>
                    <Element type="p">
                      {"Yatırımlarınız hakkında her an detaylı bilgi alabileceğiniz size özel bir"}
                      <b>{" Müşteri İlişkileri Yöneticisi"}</b>
                    </Element>
                  </li>
                  <li>
                    <Element type="p">
                      {
                        "Varlıklarınızın kalıcı bir miras olduğu bilinciyle, aile değerleriniz ve gelecek beklentilerinizle örtüşen"
                      }
                      <b>{" yenilikçi çözümler ve geniş kaynaklar"}</b>
                    </Element>
                  </li>
                </ul>
              </Block>
            </Block>
            <Image path={"./img/ozelbankacilik/bg.png"} className="landing-header-img" />
            <Block className="background">
          <Image path={"./img/ozelbankacilik/call.png"} className="landing-header-img"/>
        </Block>
          </div>
        </Col>
      </Row>
    </Block>
  )
}

export default LandingHeader
